"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal as ChakraModal, ModalOverlay, ModalContent, ModalHeader, useBreakpointValue, Box, Text, } from "@chakra-ui/react";
import { getIllustrationHeaderColor } from "./Modal.helpers";
import { Icons } from "../../../assets/icons";
import { SvgSpriteConsumer } from "../../atoms/SvgSprite";
import { ButtonVariant, IconButton } from "../../atoms";
const Modal = (_a) => {
    var { title, subTitle, children, icon, onClose, isOpen = true, closeButtonVisible = true, illustrationHeader } = _a, rest = __rest(_a, ["title", "subTitle", "children", "icon", "onClose", "isOpen", "closeButtonVisible", "illustrationHeader"]);
    const modalSize = useBreakpointValue({
        base: "mobile",
        md: "default",
    }, {
        fallback: "mobile",
    });
    const illustrationHeaderVariant = (illustrationHeader === null || illustrationHeader === void 0 ? void 0 : illustrationHeader.variant) || "info";
    return (_jsxs(ChakraModal, Object.assign({ onClose: onClose, isOpen: isOpen, isCentered: true, size: modalSize }, rest, { children: [_jsx(ModalOverlay, {}), _jsxs(ModalContent, { children: [illustrationHeader ? (_jsx(Box, Object.assign({ height: "10rem", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: getIllustrationHeaderColor(illustrationHeaderVariant) }, (!(illustrationHeader === null || illustrationHeader === void 0 ? void 0 : illustrationHeader.withoutArrow)
                        ? {
                            sx: {
                                "&:after": {
                                    content: '""',
                                    width: 0,
                                    height: 0,
                                    borderStyle: "solid",
                                    borderWidth: "24px 24px 0 24px",
                                    borderColor: "transparent",
                                    borderTopColor: getIllustrationHeaderColor(illustrationHeaderVariant),
                                    position: "absolute",
                                    bottom: "calc(100% -  10rem)",
                                    left: `calc(50% - 24px)`,
                                    transform: "translateY(100%)",
                                },
                            },
                        }
                        : {}), { children: illustrationHeader.illustration }))) : null, _jsxs(ModalHeader, { children: [icon ? (_jsx(Box, Object.assign({ sx: { mb: "6", display: "flex", justifyContent: "center" } }, { children: icon }))) : null, _jsx(Text, Object.assign({ as: "h4", noOfLines: 2, textAlign: "center" }, { children: title })), subTitle ? (_jsx(Text, Object.assign({ as: "h5", noOfLines: 2, textAlign: "center" }, { children: subTitle }))) : null] }), closeButtonVisible ? (_jsx(IconButton, { "aria-label": "Close", variant: ButtonVariant.ICON, icon: _jsx(SvgSpriteConsumer, { svgId: Icons.DELETE24, size: 24 }), onClick: onClose, sx: {
                            position: "absolute",
                            top: "0.5rem",
                            right: "0.5rem",
                        } })) : null, children] })] })));
};
Modal.displayName = "Modal";
export default Modal;
//# sourceMappingURL=Modal.js.map